
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "whoa-modal",
})
export default class extends Vue {}
